import React from "react";

function Footer() {
  return (
    <footer
      style={{
        background: "linear-gradient(90deg, #1f1f1f, #2b2b2b)",
        color: "#fff",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "30px",
          alignItems: "flex-start",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Left Section */}
        <div>
          <h4
            style={{
              marginBottom: "15px",
              fontSize: "18px",
              fontWeight: "bold",
              letterSpacing: "1px",
              color: "#4dabf7",
            }}
          >
            CONTACT DETAILS
          </h4>
          <p style={{ marginBottom: "10px" }}>
            Email:{" "}
            <a
              href="mailto:info@eaivision.com"
              style={{
                color: "#bbb",
                textDecoration: "none",
                transition: "color 0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#4dabf7")}
              onMouseLeave={(e) => (e.target.style.color = "#bbb")}
            >
              info@eaivision.com
            </a>
          </p>
          <p style={{ marginBottom: "10px" }}>
            Phone:{" "}
            <a
              href="tel:3144855835"
              style={{
                color: "#bbb",
                textDecoration: "none",
                transition: "color 0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#4dabf7")}
              onMouseLeave={(e) => (e.target.style.color = "#bbb")}
            >
              314-485-5835
            </a>
          </p>
          <p style={{ color: "#888", marginTop: "15px", fontSize: "13px" }}>
            © 2007 - 2023 GEO Federal, EAIvision LLC. <br />
            All rights reserved.
          </p>
        </div>

        {/* Right Section */}
        <div>
          <h4
            style={{
              marginBottom: "15px",
              fontSize: "18px",
              fontWeight: "bold",
              letterSpacing: "1px",
              color: "#4dabf7",
            }}
          >
            QUICK LINKS
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {[
              "Technology Vision",
              "Services",
              "Consulting",
              "Training",
              "Technology Forum",
            ].map((item, idx) => (
              <li key={idx} style={{ marginBottom: "10px" }}>
                <a
                  href={"/" + item.toLowerCase().replace(/\s+/g, "-")}
                  style={{
                    color: "#bbb",
                    textDecoration: "none",
                    fontSize: "15px",
                    transition: "color 0.3s",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#4dabf7")}
                  onMouseLeave={(e) => (e.target.style.color = "#bbb")}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
    
    </footer>
  );
}

export default Footer;
